const projectsList = [
  {
    name: 'Docker To Do List',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-17-docker-todo-list',
    image: 'https://cdn-icons-png.flaticon.com/512/4394/4394562.png',
  },
  {
    name: 'Recipes App',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-16-recipes-app',
    image: 'https://cdn-icons-png.flaticon.com/512/1065/1065711.png',
  },
  {
    name: 'Star Wars Planets Search',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-15-starwars-planets-search',
    image: 'https://cdn-icons-png.flaticon.com/512/3590/3590284.png',
  },
  {
    name: 'Trivia',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-14-trivia',
    image: 'https://cdn-icons-png.flaticon.com/512/3406/3406828.png',
  },
  {
    name: 'TrybeWallet',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-13-trybewallet',
    image: 'https://cdn-icons-png.flaticon.com/512/3258/3258446.png',
  },
  {
    name: 'React testing Library',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-12-react-testing-library',
    image: 'https://cdn-icons-png.flaticon.com/512/3281/3281329.png',
  },
  {
    name: 'Front-end Online Store',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-11-frontend-online-store',
    image: 'https://cdn-icons-png.flaticon.com/512/1390/1390737.png',
  },
  {
    name: 'TrybeTunes',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-10-trybetunes',
    image: 'https://cdn-icons-png.flaticon.com/512/3293/3293810.png',
  },
  {
    name: 'Tryunfo',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-09-tryunfo',
    image: 'https://cdn-icons-png.flaticon.com/512/4072/4072061.png',
  },
  {
    name: 'Solar System',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-08-solar-system',
    image: 'https://cdn-icons-png.flaticon.com/512/1080/1080974.png',
  },
  {
    name: 'Shopping Cart',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-07-shopping-cart',
    image: 'https://cdn-icons-png.flaticon.com/512/2331/2331970.png',
  },
  {
    name: 'Zoo Functions',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-06-zoo-functions',
    image: 'https://cdn-icons-png.flaticon.com/512/5190/5190782.png',
  },
  {
    name: 'Unit Tests',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-05-unit-tests',
    image: 'https://cdn-icons-png.flaticon.com/512/2995/2995522.png',
  },
  {
    name: 'Trybewarts',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-04-trybewarts',
    image: 'https://cdn-icons-png.flaticon.com/512/2471/2471594.png',
  },
  {
    name: 'Pixels Art',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-03-pixels-art',
    image: 'https://cdn-icons-png.flaticon.com/512/6514/6514940.png',
  },
  {
    name: 'To Do List',
    linkRepo: 'https://github.com/FredericoTP/trybe-bonus-project-todo-list',
    image: 'https://cdn-icons-png.flaticon.com/512/7246/7246748.png',
  },
  {
    name: 'Mistery Letter',
    linkRepo: 'https://github.com/FredericoTP/trybe-bonus-project-mistery-letter',
    image: 'https://cdn-icons-png.flaticon.com/512/1456/1456342.png',
  },
  {
    name: 'Meme Generator',
    linkRepo: 'https://github.com/FredericoTP/trybe-bonus-project-meme-generator',
    image: 'https://cdn-icons-png.flaticon.com/512/4104/4104669.png',
  },
  {
    name: 'Color Guess',
    linkRepo: 'https://github.com/FredericoTP/trybe-bonus-project-color-guess',
    image: 'https://cdn-icons-png.flaticon.com/512/3214/3214398.png',
  },
  {
    name: 'Playground Functions',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-02-playground-functions',
    image: 'https://cdn-icons-png.flaticon.com/512/3229/3229776.png',
  },
  {
    name: 'Lessons Learned',
    linkRepo: 'https://github.com/FredericoTP/trybe-project-01-lessons-learned',
    image: 'https://cdn-icons-png.flaticon.com/512/1575/1575305.png',
  },
  {
    name: 'Pokemon API',
    linkRepo: 'https://github.com/FredericoTP/project-pokemon-api',
    image: 'https://cdn-icons-png.flaticon.com/512/188/188987.png',
  },
];

export default projectsList;